// extracted by extract-css-chunks-webpack-plugin
module.exports = {"rootItem":"_1NNLp","rootItemTitle":"sXjyx","rootItemContent":"_3okwm","editWrapper":"_1Dupe"};